import React, { useCallback, useContext, useState } from 'react';
import Row from '../Common/Row';
import CanvasCardTitle from '../CanvasCardTitle';
import ShowOnMouseOverUnlessTour from '../ShowOnMouseOverUnlessTour';
import DashboardGadgetReportLinkButton from '../DashboardGadgetReportLinkButton';
import ContextMenu from '../../kingpin/atoms/ContextMenu';
import DashboardGadgetFilteringButton from '../DashboardGadgetFilteringButton';
import CopyGadgetButton from '../CopyGadgetButton';
import CopyDashboardGadgetToReportButton from '../CopyDashboardGadgetToReportButton';
import CopyReportGadgetButton from '../CopyReportGadgetButton/CopyReportGadgetButton';
import CopyReportGadgetToDashboardButton from '../CopyReportGadgetToDashboardButton';
import PopupGridButtonContainer from './PopupGridButtonContainer';
import PeerInfoButton from './PeerInfoButton';
import ReportGadgetEditOption from '../ReportGadgetEditOption';
import ReportGadgetContext from '../../contexts/ReportGadgetContext';
import GadgetFullscreenButton from '../GadgetFullscreen/GadgetFullscreenButton';
import { useGadgetFullscreen } from '../GadgetFullscreen/GadgetFullscreenProvider';

export const TopBar = ({
  chartDefinition,
  title,
}: {
  chartDefinition?: VisualisationDefinition;
  title: string;
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const onMenuOpen = useCallback(() => {
    setIsMenuOpen(true);
  }, []);
  const onMenuClose = useCallback(() => {
    setIsMenuOpen(false);
  }, []);
  const reportGadgetContext = useContext(ReportGadgetContext);
  const { isFullscreen } = useGadgetFullscreen();

  if (isFullscreen) {
    return (
      <Row style={{ height: '100%' }} centerAlign>
        <CanvasCardTitle title={title} />
      </Row>
    );
  }

  return (
    <Row
      spaceBetween
      style={{
        zIndex: 'unset',
        width: '100%',
        height: '100%',
      }}
      centerAlign
    >
      <CanvasCardTitle title={title} />
      <Row style={{ gap: 5 }} centerAlign>
        <ShowOnMouseOverUnlessTour>
          <DashboardGadgetReportLinkButton />
        </ShowOnMouseOverUnlessTour>

        <GadgetFullscreenButton />
        {chartDefinition && (
          <ShowOnMouseOverUnlessTour>
            <PeerInfoButton gadget={chartDefinition} />
          </ShowOnMouseOverUnlessTour>
        )}

        <ShowOnMouseOverUnlessTour isForcedVisible={isMenuOpen}>
          <ContextMenu
            buttonType="Ghost"
            onClose={onMenuClose}
            onOpen={onMenuOpen}
          >
            <>
              <ReportGadgetEditOption />
              <DashboardGadgetFilteringButton />
              {reportGadgetContext?.reportGadget ? (
                <>
                  <CopyReportGadgetToDashboardButton
                    reportGadget={reportGadgetContext.reportGadget}
                  />
                  <CopyReportGadgetButton
                    reportGadget={reportGadgetContext.reportGadget}
                  />
                </>
              ) : (
                <>
                  <CopyGadgetButton label="Copy to Dashboard" />
                  {chartDefinition && (
                    <CopyDashboardGadgetToReportButton
                      chartDef={chartDefinition}
                    />
                  )}
                </>
              )}
              <PopupGridButtonContainer chartDefinition={chartDefinition} />
            </>
          </ContextMenu>
        </ShowOnMouseOverUnlessTour>
      </Row>
    </Row>
  );
};
